let swiper;
window.addEventListener("load", function() {
    swiper = new Swiper('.main-swiper', {
        direction: "vertical",
        slidesPerView: 1,
        effect: 'fade',
        preloadImages: false,
        mousewheel: true,
        allowTouchMove: false,
        lazy: {
            loadPrevNext: false,
            loadOnTransitionStart: false,
        },
        on: {
            slideChange() {
                // const $nav = $('#vxphl-ld-25-a-navigation');
                // if (!$nav.length) return;
                // if ($('body').data('device-type') === 'desktop') {
                //   if (this.activeIndex > 0) $nav.hide(); else $nav.show();
                // }
            }
        }
    });

    // Export to window for global access
    window.swiper = swiper;

    const $nav = $('#vxphl-ld-25-a-navigation');
    if ($nav.length) $nav.toggle(swiper.activeIndex === 0);
});

let allowScrollTrigger = true;
let touchStartY = 0;

window.addEventListener('touchstart', function(e) {
    touchStartY = e.touches[0].clientY;
});

window.addEventListener('touchend', function(e) {
    const touchEndY = e.changedTouches[0].clientY;
    const deltaY = touchStartY - touchEndY;

    const scrollTop = window.scrollY;
    const windowHeight = window.innerHeight;
    const docHeight = document.documentElement.scrollHeight;

    // Vuốt lên → nếu gần cuối trang thì slideNext
    if (deltaY > 30 && Math.abs(docHeight - (scrollTop + windowHeight)) < 5) {
        swiper.slideNext();
    }

    // Vuốt xuống → nếu gần đầu trang thì slidePrev
    else if (deltaY < -30 && scrollTop < 5) {
        swiper.slidePrev();
    }
});

scaleLeftMenu();
window.addEventListener("load", function() {
    scaleLeftMenu()

});
window.addEventListener("resize", function() {
    scaleLeftMenu();
});


function scaleLeftMenu() {
    let scaleRatio = $('body').data("scale-ratio");
    console.log("scaleRatio" + scaleRatio);
    $(".main-left-h5").css({
        transform: `scale(${scaleRatio})`,
        transformOrigin: 'left top'
    });
}
$(function() {
    const targets = document.querySelectorAll('.MS__popup');
    if (!targets.length) return;

    const prevClassMap = new Map();

    // Helper function để xử lý class thay đổi
    const handleActiveChange = (target, isActive) => {
        const msOuter = target.closest('.MS__outer');
        const layerPopup = document.querySelector('.layer__popup');

        if (isActive) {
            if (layerPopup) {
                layerPopup.classList.add('active');
            }
            if (msOuter) {
                msOuter.classList.add('activepopup');
            }
        } else {
            if (layerPopup) {
                layerPopup.classList.remove('active');
            }
            if (msOuter) {
                msOuter.classList.remove('activepopup');
            }
        }
    };

    // Lưu trữ class ban đầu của mỗi element
    targets.forEach(target => {
        prevClassMap.set(target, target.className);

        // Track ngay lúc load: nếu đã có class active
        if (target.className.includes('active')) {
            handleActiveChange(target, true);
        }
    });

    const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
            if (mutation.attributeName !== 'class') return;

            const target = mutation.target;
            const prevClass = prevClassMap.get(target) || '';
            const currentClass = target.className;

            const wasActive = prevClass.includes('active');
            const isActive = currentClass.includes('active');

            if (wasActive !== isActive) {
                handleActiveChange(target, isActive);
            }

            prevClassMap.set(target, currentClass);
        });
    });

    // Theo dõi tất cả các elements
    targets.forEach(target => {
        observer.observe(target, {
            attributes: true,
            attributeFilter: ['class']
        });
    });
});